<template>
  <div class="qr">
    <div id="qrcode" ref="qrCodeImg"></div>
    <!-- <div class="img-div">
      <img class="header-img" :src="avatarName" alt="">
    </div> -->
  </div>
</template>
<script>
import QRCode from "qrcodejs2";

export default {
  data() {
    return {
      text: '',
      userid: '',
      baseurl: 'https://dtfcloud.com/',
    };
  },
  mounted(){
    setTimeout(this.creatQrCode(),100)
  },
  methods: {
    // 生成二维码页面
    creatQrCode() {
      var qrcode = new QRCode(this.$refs.qrCodeImg, {
        // text: this.commonUrl.F_URL+'#/'+'?pid='+localStorage.getItem('userid'), //生成二维码的内容（链接或者其他）
        text: process.env.VUE_APP_BASE_URL+'?pid='+localStorage.getItem('userid'), //生成二维码的内容（链接或者其他）
        width: 100, //生成的二维码的宽度
        height: 100, //生成的二维码的高度
        colorDark: "#000000", // 生成的二维码的深色部分
        colorLight: "#ffffff", //生成二维码的浅色部分
        correctLevel: QRCode.CorrectLevel.L,//纠错等级
      });
    },


  },
};
</script>
<style lang="less" scoped>
#qrcode {
  width: 35px;
  height: 35px;
  background: #fff;
  padding: 1.5px;
  /deep/ img {
    width: 100% !important;
    height: 100% !important;
  }
  /deep/ canvas{
    width: 100% !important;
    height: 100% !important;
  }
}
</style>
